module.exports = __webpack_public_path__ + "media/images/hero/hero-bg6-2b0ff245ae474126d726c5ed1802210b.jpg";